"use client"

import { ScanText } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ScanTextIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ScanTextIcon = component(Icon)({ as: ScanText })
